/**
 * 大六壬 · 十二天将布将
 *
 * 布将三步：
 * 1. 由日干取昼贵 / 夜贵（贵人诀），再以占时定昼夜 → 得贵人落于**地盘**何宫；
 * 2. 贵人所乘为天盘该宫之上的神；
 * 3. 贵人临地盘 亥子丑寅卯辰（阳位）顺布，临 巳午未申酉戌（阴位）逆布，
 *    十二天将按 贵人→螣蛇→朱雀→六合→勾陈→青龙→天空→白虎→太常→玄武→太阴→天后 依次排布。
 */
import { TIAN_JIANG, guiRen, isDayTime, zhiOf } from './constants';
/**
 * 布十二天将。
 *
 * @param dayGanIndex 日干索引 0..9
 * @param zhanShiIndex 占时地支索引 0..11
 * @param tianPan 天盘数组（tianPan[i] = 地盘第 i 宫之上的天盘支）
 */
export function buildTianJiang(dayGanIndex, zhanShiIndex, tianPan) {
    const [dayGui, nightGui] = guiRen(dayGanIndex);
    const day = isDayTime(zhanShiIndex);
    const guiRenIdx = day ? dayGui : nightGui;
    const guiRenGong = zhiOf(guiRenIdx);
    // 贵人临地盘六阳位（亥子丑寅卯辰）顺布，六阴位（巳午未申酉戌）逆布
    const direction = guiRenIdx === 11 || guiRenIdx <= 4 ? '顺' : '逆';
    const dir = direction === '顺' ? 1 : -1;
    const items = [];
    const byTianPanZhi = {};
    for (let p = 0; p < 12; p += 1) {
        const offset = (((p - guiRenIdx) * dir) % 12 + 12) % 12;
        const jiang = TIAN_JIANG[offset];
        const zhi = tianPan[p];
        items.push({ zhi, jiang, gong: zhiOf(p) });
        byTianPanZhi[zhi] = jiang;
    }
    return {
        items,
        guiRenGong,
        direction,
        dayNight: day ? '昼' : '夜',
        guiRenZhi: zhiOf(guiRenIdx),
        byTianPanZhi,
    };
}
//# sourceMappingURL=tianJiang.js.map